import React, { Component } from 'react';
import { List, Avatar, message, Input, Button, Tag, Menu, Dropdown } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const Search = Input.Search;

class Videos extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {title: '', body: ''};
    this.state = {redirect: false, videos: [], filteredVideos: [], videoModal: false};
    this.validateToken = this.validateToken.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getVideos = this.getVideos.bind(this);
    this.videoMenu = this.videoMenu.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getVideos();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});

    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or gerente or empleado or guardia"))
      this.setState({redirect: true});
  }

  getVideos() {
    let url = `${Configuration.apiServer}/api/v1/videos`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');
      
      this.setState({videos: resp.data, filteredVideos: resp.data});
    });
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/videos`, {video: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro creado');
      this.handleCloseModal();
      this.getVideos();
    });
  }

  handleSearch(event) {
    const videos = this.state.videos.filter(video => {
      return video.titile.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1 || video.body.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredVideos: videos});
  }

  videoMenu(video) {
    let submenus = [<Menu.Item key="video:show"><a href={`/support/videos/${video.id}`}>Ver video</a></Menu.Item>];
    return (<Menu>{submenus}</Menu>);
  }
 
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Videos para capacitación</h3>

            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%'}} />
          </div>

          <br/> <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <List
              className="demo-loadmore-list"
              itemLayout="vertical"
              style={{ width: '100%' }}
              dataSource={this.state.filteredVideos}
              renderItem={video => (
                <List.Item>
                  <div className="d-flex align-items-center justify-content-between">
                    <Avatar icon="picture" />
                    
                    <div style={{ width: '90%' }}>
                      <h6 className="d-flex justify-content-between align-items-center" style={{ marginBottom: '0px' }}>
                        <span>{video.title}</span> 
                        <div>
                          <Tag color="cyan">{Configuration.formatDatetime(video.created_at)}</Tag>
                        </div>
                      </h6>
                      <p style={{ marginTop: '20px' }}>
                        <span>Detalles: {(video.body) ? video.body : 'Sin detalles'}</span>
                      </p>
                    </div>

                    <Dropdown overlay={this.videoMenu(video)}>
                      <span className="ant-dropdown-link">
                        <Button icon="ellipsis" shape="circle" style={{ background: '#eee' }} />
                      </span>
                    </Dropdown>
                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
          
      </div>
    );
  }
}

export default Videos;



// WEBPACK FOOTER //
// ./src/pages/public/Videos.js